export default {
  name: 'IndustrialModelItem',
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  }
};